import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  root: {
    padding: 0,
    '& .MuiPaper-root': {
      width: '100%',
    },
  },

  content: {
    display: 'grid',
    gap: spacing(52),
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'auto 1fr auto auto',
    gridTemplateAreas: `
    "aiAssistantName serviceOrder"
    "explanation explanation"
    "createdAt userName"
    "statusApi statusApi"
  `,
  },
  link: {
    fontSize: spacing(16, '!important'),
    fontWeight: '400 !important',
    marginTop: spacing(2),
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  inputLabel: {
    display: 'flex',
    color: palette.gray[64],
    fontSize: spacing(12),
    marginTop: -16,
  },
  label: {
    width: '100%',
    paddingBottom: '10px',
    color: Theme.Colors.Grayscale.SixtyFour,
    fontSize: spacing(14),
    marginBottom: spacing(4),
  },
  linkContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(6),
  },
}))
